import React, { Component } from 'react';

class ReadyThemes extends Component {

  render() {
    return (<>

      {/* [ Main Content ] start */}
      <div className="pc-container">
        <div className="pc-content">
          {/* [ breadcrumb ] start */}
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item"><a href="#"><i className="ti ti-home-2" /></a></li>
                    <li className="breadcrumb-item"><a href="javascript: void(0)">Merchant</a></li>
                    <li className="breadcrumb-item" aria-current="page">Themes</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* [ breadcrumb ] end */}
          {/* [ Main Content ] start */}
          <div className="row">
            {/* [ dashboard-ui-1 ] start */}
            <div className="col-xl-4 col-md-6">
              <div className="card">
                <img className="img-fluid" src="assets/images/widget/dashborad-1.jpg" alt="dashboard-user" />
                <div className="card-body">
                  <h5>Fylance Defult Theme</h5>
                  <span className="text-muted">Set your defult merchant theme here</span>
                  <div className="row m-t-30">
                    <div className="col-6 p-r-0">
                      <div className="d-grid">
                        <a href="#!" className="btn btn-primary text-uppercase">Active</a>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="d-grid">
                        <a href="#!" className="btn text-uppercase border btn-outline-secondary">Edit</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* [ dashboard-ui-1 ] end */}
            <div className="col-xl-4 col-md-12">
              <div className="card">
                <div className="card-body p-0">
                  <img className="img-fluid" style={{ width: '100%' }} src="assets/images/widget/dashborad-2.jpg" alt="dashboard-user" />
                  <div className="ux-designer">
                    <button className="btn btn-primary"><i className="ti ti-plus" /></button>
                    <h5>Add your new merchant theme</h5>
                    <span>UX &amp; UI Design</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* [ Main Content ] end */}
        </div>
      </div>
      {/* [ Main Content ] end */}




    </>);
  };
}

export default ReadyThemes;
